import {WhitelabelConfig} from "./WhitelabelConfig";
import {CompanyEnumIndices} from "@bdswiss/common-enums";

export const tauroMarkets: WhitelabelConfig = {
    whitelabel: CompanyEnumIndices.tauroMarkets,
    domainNames: [
        'tauromarkets.com',
        'tauromarkets.local',
        'tauromarkets.skyground-staging.com'
    ],
    leverageOverrides: {
        "XAGUSD.fx": 200,
        "XAUUSD.fx": 200,
    }
}
